import * as React from 'react';
import { sanitize } from 'dompurify';
import { isSearchEnhancementsMilestone1Enabled } from 'feature-flags';
import BookIcon from '@atlaskit/icon/glyph/book';
import DocumentIcon from '@atlaskit/icon/glyph/media-services/document';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import type { SearchProps } from '@atlassian/help-center-common-component/result-base';
import { addParamsToUrl } from '@atlassian/help-center-common-util/history-qs';
import { LinkContainer, Title, ArticleContainer, Snippet, ServiceDeskTitle } from './styled';

interface KbSearchProps extends SearchProps {
    titleHtml: string;
    to: string;
    actionSubjectId: string;
    snippet?: string;
    openNewTab?: boolean;
    isSuggestion?: boolean;
    showPortalName?: boolean;
    portalName?: string;
}

const KbSnippet: React.FC<KbSearchProps> = ({
    titleHtml,
    to,
    actionSubjectId,
    openNewTab,
    onClick,
    snippet,
    queryHash,
    portalName,
    showPortalName = false,
    ...props
}) => {
    return (
        <LinkContainer
            to={addParamsToUrl(to, { src: queryHash })}
            key={to}
            onClick={onClick}
            actionSubjectId={actionSubjectId}
            target={openNewTab ? '_blank' : '_self'}
            data-test-id="article-link-container"
            {...props}
        >
            {isSearchEnhancementsMilestone1Enabled() ? (
                <DocumentIcon label="" size="medium" />
            ) : (
                <BookIcon label="" size="large" primaryColor={token('color.icon', colors.N500)} />
            )}
            <ArticleContainer snippets={snippet}>
                <Title dangerouslySetInnerHTML={{ __html: sanitize(titleHtml) }} />
                {showPortalName && portalName && <ServiceDeskTitle>from {portalName}</ServiceDeskTitle>}
                {snippet && <Snippet dangerouslySetInnerHTML={{ __html: sanitize(snippet) }} />}
            </ArticleContainer>
        </LinkContainer>
    );
};
export default KbSnippet;
